import {
  ChangeDetectionStrategy,
  Component,
  input,
  viewChild,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-sidenav-link',
  template: `
    <a
      [routerLink]="linkTo()"
      routerLinkActive
      [routerLinkActiveOptions]="{ exact: exact() }"
      class="group-data-active:text-primary flex h-full items-center text-inherit no-underline"
    >
      <mat-icon class="mr-3">{{ icon() }}</mat-icon>
      <span class="text-sm group-data-active:font-bold">{{ title() }}</span>
    </a>
  `,
  imports: [MatIconModule, RouterLink, RouterLinkActive],
  host: {
    class: `block group px-4 text-gray-700 hover:bg-gray-100 active:bg-gray-200 data-active:bg-primary-light`,
    '[attr.data-active]': 'rla().isActive || null',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavLinkComponent {
  readonly icon = input.required<string>();
  readonly title = input.required<string>();
  readonly linkTo = input.required<RouterLink['routerLink']>();
  readonly exact = input<boolean>(false);
  readonly rla = viewChild.required(RouterLinkActive);
}
